<template>
  <v-card color="" elevation="0" class="px-4">
    <v-divider></v-divider>
    <div class="d-flex align-strech pt-3 pb-7 mt-2">
      <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
        :label="this.$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="success" height="40" elevation="0" class="ml-2" @click="addNew()">{{ $t("common.add") }}</v-btn>
      <v-btn color="success" @click="importer.show = true" outlined height="40" class="ml-2" elevation="0">{{
        $t("common.import") }}
        <v-icon class="ml-3" small>mdi-upload</v-icon></v-btn>

      <vue-json-to-csv :json-data="documents" :csv-title="`Clientes reservados (${computedDateFormatted}) `"
        :separator="';'" :labels="csvLabels">
        <v-btn outlined color="primary" height="40" class="ml-2">
          {{ $t("common.export") }}

          <v-icon>mdi-download</v-icon>
        </v-btn>
      </vue-json-to-csv>
    </div>
    <v-card outlined>
      <v-data-table :loading="loading" :sort-by="['log']" :sort-desc="[false]" :headers="headers" :items="documents"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 25, 50],
        }" :items-per-page="25"> <!--  :search="search" -->
        <template v-slot:[`item.createdOn`]="{ item }">
          <span class="hide-text">{{ item.createdOn }}</span>{{ item.createdOn | dateTimeFromUTC }}
        </template>

        <template v-slot:[`item.score`]="{ item }">
          <div class="d-flex align-center align-middle" style="width: 280px">
              
              <span v-if="!item.openScore">
                <template v-if="item.score == 0">Pendente</template>
                <template v-if="item.score == 1">Em análise</template>
                <template v-if="item.score == 2">Inadimplente</template>
                <template v-if="item.score == 3">Gold (30dfm)</template>
                <template v-if="item.score == 4">Silver (15dfm)</template>
                <template v-if="item.score == 5">Bronze (à vista)</template>
              </span>
              <v-btn small text class="ml-1" v-if="!item.openScore" @click="item.openScore = !item.openScore"><v-icon small>mdi-pencil</v-icon></v-btn>
              <v-select v-if="item.openScore" outlined dense hide-details :items="[
                { id: 0, label: 'Pendente'}, 
                {id: 1, label: '⁠Em análise'}, 
                {id: 2, label:'Inadimplente'}, 
                {id: 3, label: 'Gold (30dfm)'}, 
                {id: 4, label: 'Silver (15dfm)'}, 
                {id: 5, label: 'Bronze (à vista)'}
              ]" item-value="id" item-text="label" v-model="item.newScore"></v-select>
              <v-btn @click="saveScore(item)" v-if="item.openScore" color="success" outlined class="ml-1 mb-1">Salvar</v-btn>
          </div>
       
       </template>


      

        <template v-slot:[`item.log`]="{ item }">
          <span v-html="lastLog(item)"></span><v-btn icon small
            @click="openHistory(item)"><v-icon>mdi-history</v-icon></v-btn>
        </template>

        <template v-slot:[`item.id`]="{ item }">
          <v-btn icon small @click="edit(item)" class="mr-1"><v-icon>mdi-pencil-outline</v-icon></v-btn>

          <v-btn icon small color="red" @click="remove(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog :max-width="[1, 2, 3].includes(add.form.status) ? 900 : 630" v-model="add.show">
      <v-card class="mx-auto">
        <v-card-title v-if="!add.form.id">{{ $t("sales.reserved.add.title") }}</v-card-title>
        <v-card-title v-if="add.form.id">Editar cliente reservado</v-card-title>
        <v-card-subtitle>{{
          $t("sales.reserved.add.subtitle")
        }}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <fieldset class="pa-3">
                <legend>
                  {{ $t(`sales.reserved.add.form.registerData`) }}
                </legend>
                <v-text-field v-model="add.form.name" @input="v$.add.form.name.$touch()" @blur="v$.add.form.name.$touch()"
                  :error-messages="nameErrors" :label="$t(`sales.reserved.add.form.name`)"></v-text-field>

                <v-text-field :disabled="add.form.id" v-if="documentMask" @input="v$.add.form.document.$touch()"
                  @blur="v$.add.form.document.$touch()" :error-messages="documentErrors" v-model="add.form.document"
                  v-mask="documentMask" :loading="checkingDocument" :label="documentName"></v-text-field>
                <v-text-field :disabled="add.form.id" v-else :error-messages="docErrors" v-model="add.form.document"
                  :loading="checkingDocument" :label="documentName"></v-text-field>
              </fieldset>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn text @click="add.show = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn color="success" :disabled="processing || docErrors" :loading="processing" @click="submit()"
            elevation="0">{{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :max-width="768" v-model="importer.show">
      <v-card class="mx-auto" v-if="!importResult">
        <v-card-title>{{ $t("sales.reserved.import.title") }}</v-card-title>
        <!-- <v-card-subtitle>Envie uma lista para ser adicionada.</v-card-subtitle> -->
        <v-card-text>
          <template v-if="!importer.json.length">
            <v-file-input @change="onChange" :label="$t('sales.reserved.import.select')"></v-file-input>
          </template>
          <template v-else>
            <template v-if="importer.json.length">
              <p>Foram encontrados <strong>{{ importer.json.length }} registros</strong> para importar.</p>
              <p>Cliquem em importar para processar a lista.</p>
            </template>
          </template>
          <!-- <template v-else>
            <div class="text-h6 font-weight-bold">
              {{ $t("sales.reserved.import.selectLine") }}
            </div>
            <template v-if="importer.startLine">
              <div class="text-h6 font-weight-bold">
                {{ $t("sales.reserved.import.changeLine") }}
              </div>

              <div class="d-flex">
                <div style="flex: 1 1 50%">
                  <v-card class="ma-1 py-2 px-1" outlined>
                    {{ $t("sales.reserved.add.form.name") }}
                  </v-card>

                  <v-card class="ma-1 py-2 px-1" outlined>
                    {{ $t("sales.reserved.add.form.document") }}
                  </v-card>


                </div>
                <div>
                  <v-card class="ma-1 py-2 px-1" elevation="0">
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-card>
                  <v-card class="ma-1 py-2 px-1" elevation="0">
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-card>

                </div>
                <div style="flex: 1 1 100%">
                  <v-card class="ma-1 py-2 px-1" width="100%" outlined v-for="(item, i) in items" :key="i"
                    @dragover="(e) => onDragOver(item, i, e)" @dragend="(e) => finishDrag(item, i, e)"
                    @dragstart="(e) => startDrag(item, i, e)" draggable="true">
                    <div :style="i > 20 ? 'opacity: 0.5' : 'opacity: 1'">
                      {{ item }}
                    </div>
                  </v-card>
                </div>
              </div>
             <div class="d-flex py-2">
                <v-spacer></v-spacer>
                <v-btn elevation="0" @click="preview()" color="primary">{{
                  $t("sales.reserved.import.preview")
                }}</v-btn>
              </div>
              <template v-if="importer.json.length">
                {{  importer.json.length }} registros a importar. Clique em importar para confirmar.
              </template>
          <template v-if="importer.preview">
                <table width="100%" style="border-collapse: collapse" cellpadding="5">
                  <thead>
                    <tr>
                      <th class="text-left" style="border: 1px solid #e0e0e0; padding: 5px">
                        {{ $t("sales.reserved.add.form.name") }}
                      </th>

                      <th class="text-left" style="border: 1px solid #e0e0e0; padding: 5px">
                        {{ $t("sales.reserved.add.form.document") }}
                      </th>

                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, i) in importer.json">
                      <tr :key="i" v-if="i >= importer.startLine - 1">
                        <td style="border: 1px solid #e0e0e0; padding: 5px">
                          {{ item[importer.list[0]] }}
                        </td>
                        <td style="border: 1px solid #e0e0e0; padding: 5px">
                          {{ item[importer.list[1]] }}
                        </td>

                      </tr>
                    </template>
                  </tbody>
                </table>
              </template>
            </template>
          </template> -->
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn text @click="importer.show = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn color="success" :loading="importer.processing" :disabled="!importer.preview" @click="toImport()"
            elevation="0">{{ $t("common.import") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mx-auto" v-if="importResult">
        <v-card-title>O resultado da importação é:</v-card-title>
        <v-card-text>
          <div class="d-flex">
            <v-alert width="100%" text color="success" class="pa-3 mr-3" outlined>
              <h2 class="text-center">{{ importResult.success }}</h2>
              <h5 class="text-center">novos registros adicionados</h5>
            </v-alert>
            <v-alert width="100%" text color="error" class="pa-3 mr-3" outlined>
              <h2 class="text-center">{{ countObject(importResult.errors) }}</h2>
              <h5 class="text-center">registros com falha</h5>
              <v-btn @click="openErrors = !openErrors" outlined color="error" block small class="mt-3">Ver
                registros</v-btn>
            </v-alert>
          </div>
          <v-card class="pa-3 mt-3" v-if="openErrors">
            <v-card outlined>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Loja
                      </th>
                      <th class="text-left">
                        CNPJ
                      </th>
                      <th class="text-left">
                        Descrição
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, k) in importResult.errors" :key="k">
                      <td>{{ k }}</td>
                      <td>{{ $t(item[0][1]) }}</td>

                      <td>{{ $t(item[0][0]) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-card>
          <div class="d-flex pt-3">
            <v-spacer></v-spacer>
            <v-btn text @click="resetImport()" class="mr-1">Importar novamente</v-btn>
            <v-btn color="success" @click="importer.show = false" elevation="0">Confirmar</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="historic.show" width="540">
      <v-card class="mx-auto" v-if="historic.show && historic.item">
        <v-card-title>{{ $t("sales.reserved.historic") }}</v-card-title>
        <v-card-text>
          <div v-for="(item, i) in historic.item.log" :key="i">
            <v-card outlined class="pa-2 mb-2">
              <div class="d-flex">
                <div class="mb-2 mr-4">
                  <label>IP</label>
                  <div class="text-p font-weight-bold">{{ item.ip }}</div>
                </div>
                <div class="mb-2 mr-4">
                  <label>Data</label>
                  <div class="text-p font-weight-bold">
                    {{ item.createdOn | dateTime }}
                  </div>
                </div>
                <div class="mb-2">
                  <label>Empresa</label>
                  <div class="text-p font-weight-bold">
                    {{ item.company }}
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <div class="mb-2 mr-4">
                  <label>{{ $t("auth.user.email.label") }}</label>
                  <div class="text-p font-weight-bold">
                    {{ item.email }}
                  </div>
                </div>
                <div class="mb-2">
                  <label>Telefone</label>
                  <div class="text-p font-weight-bold">
                    {{ item.phone }}
                  </div>
                </div>
              </div>

            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="toDelete" width="480">
      <v-card class="mx-auto">
        <v-card-title class="d-flex justify-space-between">{{ $t("sales.reserved.deleteTitle")
        }}<v-btn icon color="grey" @click="toDelete = false"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-card-subtitle>{{ $t("sales.reserved.deleteSubTitle") }}
        </v-card-subtitle>
        <v-card-actions class="d-flex justify-end pa-4">
          <v-btn text @click="toDelete = false">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn @click="removeReserved()" color="error" elevation="0">Borrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar style="top: 70px" top right :timeout="5000" v-model="removed">
      {{ $t("sales.reserved.snackMsgErr") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" icon v-bind="attrs" @click="removed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
import coutriesConfig from "@/store/countries";
import moment from "moment";
import { utils, read } from "xlsx";
import config from "@/store/config";
import { mapActions } from "vuex";
import VueJsonToCsv from "vue-json-to-csv";
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import validations from '@/plugins/validations'
import { TheMask } from 'vue-the-mask'
import axios from 'axios'


const isValidPeruRUC = (value) => validations.isValidPeruRUC(value)
const isCompanyPeruRUC = (value) => validations.isCompanyPeruRuc(value)

export default {
  name: "ReservedList",
  components: {
    VueJsonToCsv,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      add: {
        form: {
          document: { required, validFormat: isValidPeruRUC, isCompanyDoc: isCompanyPeruRUC },
          name: { required, minLength: minLength(3), maxLength: maxLength(50) }
        }
      }
      // // if(this.assets.countries[this.country].code == 'PER'){
      //   validationsList.form.document.validFormat = isValidPeruRUC
      // // }

      // return validationsList
    }
  },

  data() {
    return {
      calling: null,
      openErrors: false,
      importResult: null,
      alreadyRegistered: false,
      alreadyReserved: false,
      checkingDocument: false,
      reservedId: null,
      allDocs: [],
      historic: {
        show: false,
        item: null,
      },
      removeSnap: null,
      toDelete: false,
      removed: false,
      calendarPicker: false,

      dragover: false,
      over: {},
      startLoc: 0,
      dragging: false,
      dragFrom: {},
      processing: false,
      importer: {
        preview: false,
        list: [],
        show: false,
        processing: false,
        json: [],
        columnsOrder: [],
        startLine: 2,
      },
      importerModel: {
        preview: false,
        list: [],
        show: false,
        processing: false,
        json: [],
        columnsOrder: [],
        startLine: 2,
      },
      file: null,
      add: {
        show: false,
        form: {
          name: "",
          document: ""

        },
        model: {
          name: "",
          document: ""

        },
      },
      csvLabels: {},
      loading: true,
      search: this.$route.query.q ? this.$route.query.q : "",

      documents: [],
      items: [],
    };
  },
  mounted() {
    this.loadDocuments();
    this.csvLabels = {
      name: { title: this.$t("sales.reserved.add.form.name") },
      document: {
        title: coutriesConfig && coutriesConfig[this.$root.auth.whitelabel.country] && coutriesConfig[this.$root.auth.whitelabel.country]
          .companyDocument
          ? coutriesConfig[this.$root.auth.whitelabel.country].companyDocument
          : "Document",
      }

    };
    // for(let i=0; i<4; i++){
    //     this.statusList[i].text = this.$t(`sales.reserved.status[${i}]`)
    // }

    // const key = this.$root.auth.whitelabel.country
    // console.log('key', key)
    // const text = coutriesConfig[key].companyDocument
    // console.log('text document', text)
    // this.headers[2].text = text
  },
  watch: {
    'add.form.document'(v) {
      if (!this.v$.add.form.document.$invalid) {
        this.checkingDocument = true
        this.checkDocument()
      }
    },
    'search': {
      handler() {
        this.loadDocuments()
      }
    },
    "$route.params.tab"(value) {
      if (value != 1)
        this.search = this.$route.query.q ? this.$route.query.q : "";
    },
    "add.show"(value) {
      if (!value) {
        this.add.form = JSON.parse(JSON.stringify(this.add.model));
        this.processing = false
        this.checkingDocument = false
        this.alreadyRegistered = false
        this.alreadyReserved = false
      }
    },
    "importer.show"(value) {
      if (!value) {
        this.importResult = null
        this.importer = JSON.parse(JSON.stringify(this.importerModel));
      }
    },
    importTitles: {
      deep: true,
      handler(val) {
        this.items = val;
      },
    },
  },
  computed: {
    documentErrors() {
      const errors = [];
      if (!this.add.show) return errors
      this.alreadyRegistered && errors.push('Ya existe una cuenta que utiliza este documento.')
      this.alreadyReserved && errors.push('Ya existe una reserva con este documento')
      if (!this.v$.add.form.document.$dirty && !errors.length)
        return errors;


      this.v$.add.form.document.required.$invalid && errors.push(this.$t('sales.reserved.errors.document.required', { doc: 'RUC' }))
      this.v$.add.form.document.validFormat.$invalid && errors.push(this.$t('sales.reserved.errors.document.invalid', { doc: 'RUC' }));
      this.v$.add.form.document.isCompanyDoc.$invalid && errors.push(this.$t('sales.reserved.errors.document.noCompanyDoc', { doc: 'RUC' }))
      return errors;
    },

    nameErrors() {
      const errors = []
      if (!this.add.show) return errors

      if (!this.v$.add.form.name.$dirty) return errors
      this.v$.add.form.name.minLength.$invalid && errors.push(this.$t('sales.reserved.errors.name.minLength', { count: 3 }))
      this.v$.add.form.name.maxLength.$invalid && errors.push(this.$t('sales.reserved.errors.name.maxLength', { count: 50 }))
      this.v$.add.form.name.required.$invalid && errors.push(this.$t('sales.reserved.errors.name.required'))
      return errors
    },

    docErrors() {
      if (this.alreadyRegistered) {
        return 'Ya existe una cuenta que utiliza este documento.'
      }
      if (this.alreadyReserved) {
        return 'Ya existe una reserva con este documento'
      }
      return false
    },
    headers() {
      return [
        // { text: 'ID', value: 'uid' },
        {
          text: this.$t("sales.reserved.add.form.name"),
          align: "start",
          sortable: true,
          value: "name",
        },

        {
          text: coutriesConfig && coutriesConfig[this.$root.auth.whitelabel.country] && coutriesConfig[this.$root.auth.whitelabel.country]
            .companyDocument
            ? coutriesConfig[this.$root.auth.whitelabel.country].companyDocument
            : "Document",
          align: "start",
          sortable: true,
          value: "document",
        },

        {
          text: this.$t("sales.reserved.add.form.score"),
          align: "start",
          sortable: true,
          value: "score",
        },

        {
          text: this.$t("sales.reserved.add.form.log"),
          align: "start",
          sortable: true,
          value: "log",
        },
        {
          text: this.$t("sales.reserved.add.form.createdOn"),
          align: "start",
          sortable: true,
          value: "createdOn",
        },

        { text: "", align: "end", value: "id" },
      ];
    },

    documentName() {
      return coutriesConfig && coutriesConfig[this.$root.auth.whitelabel.country] && coutriesConfig[this.$root.auth.whitelabel.country].companyDocument
        ? coutriesConfig[this.$root.auth.whitelabel.country].companyDocument
        : "Documento";
    },
    documentMask() {
      const m = coutriesConfig && coutriesConfig[this.$root.auth.whitelabel.country] && coutriesConfig[this.$root.auth.whitelabel.country]
        .companyDocumentMask
        ? coutriesConfig[this.$root.auth.whitelabel.country].companyDocumentMask
        : "";
      console.log('M', m)
      return m
    },
    computedDateFormatted() {
      return moment().format("YYYY-MM-DD HH mm");
    },
    importLinesNumber() {
      if (this.importer.json.length) {
        const res = [];
        for (let i = 0; i < this.importer.json.length; i++) {
          res.push(parseInt(i) + 1);
        }
        return res;
      } else {
        return [];
      }
    },
    importColumnsNumber() {
      if (this.importer.json.length) {
        for (
          let i = 0;
          i < this.importer.json[this.importer.startLine - 1];
          i++
        ) {
          res.push(parseInt(i) + 1);
        }
        return res;
      } else {
        return [];
      }
    },
    importTitles() {
      if (this.importer.json.length && this.importer.startLine) {
        const val = this.importer.json[this.importer.startLine - 1];
        const items = [];
        val.forEach((v, i) => {
          items.push(`${i + 1} - ${v}`);
        });

        return items;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    countObject(obj) {
      return (Object.keys(obj).length)
    },
    saveScore(item){
        item.score = item.newScore
        const id = item.id
        this.processing = true;
        const form = {
          companyName: item.name,
          document: item.document,
          storeId: config.projectId,
          score: item.score,
        }
      if (id) {
        form.id = id
        const url = `whitelabel/reserved/update`;
        this.$axios.put(url, form).then(() => {
          item.openScore = false
          this.loadDocuments()
        });
      }

    },
    resetImport() {
      this.importer.preview = false
      this.importResult = null
      this.importer.list = []
      this.importer.processing = false
      this.importer.json = []
      this.importer.columnsOrder = []
      this.importer.startLine = null
    },
    checkDocument() {
      if (!this.add.form.id) {
        this.alreadyRegistered = false
        this.alreadyReserved = false
        this.$axios.get(`whitelabel/reserved/list?storeId=${config.projectId}&document=${this.add.form.document}`).then((r) => {
          if (r.data.data.length) {
            this.alreadyReserved = true
          }

          this.checkingDocument = false
        })
      }
      else {
        this.checkingDocument = false
      }
    },
    openHistory(item) {
      this.historic.show = true;
      this.historic.item = item;
    },
    lastLog(item) {
      if (!item.hasOwnProperty("log")) return "-";
      console.log('item.log', item.log)
      const lengthLog = item.log.length;
      if (!lengthLog) return "-"
      const lastLog = item.log[item.log.length - 1];
      console.log('lastLog', lastLog)
      if (lengthLog > 1) {
        return `<span style="font-size: 0;">${moment(lastLog.createdOn).format(
          "X"
        )}"></span>${moment(lastLog.createdOn).format("LLL")} (${lengthLog - 1
          } intentos mas)`;
      }
      else {
        return `<span style="font-size: 0;">${moment(lastLog.createdOn).format(
          "X"
        )}"></span>${moment(lastLog.createdOn).format("LLL")}`;
      }
    },
    addNew() {
      this.add.form = JSON.parse(JSON.stringify(this.add.model));
      this.objectId()
      this.add.show = true;
    },
    edit(item) {
      this.add.form = item;
      this.add.show = true;
      //console.log('id',item.id)
    },
    remove(item) {
      this.removeSnap = item;
      this.toDelete = true;
    },
    removeReserved() {
      const form = { ...this.removeSnap, storeId: config.projectId }
      const url = `whitelabel/reserved/delete`;
      this.$axios.put(url, form).then(() => {
        this.reservedId = ''
        this.showSnack({
          text: this.$t("sales.reserved.snackMsgErr"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        this.toDelete = false
        this.add.show = false;
        this.loadDocuments()
      });
    },
    objectId(id) {
      if (id) {
        this.reservedId = id
      } else {
        var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
        return (
          this.reservedId = timestamp +
          "xxxxxxxxxxxxxxxx"
            .replace(/[x]/g, () => {
              return ((Math.random() * 16) | 0).toString(16);
            })
            .toLowerCase()
        );
      }

    },
    toImport() {
      this.importer.processing = true
      const data = []
      this.importer.json.forEach((item, i) => {
        if (i >= this.importer.startLine - 1) {
          const row = {
            companyName: item[this.importer.list[0]],
            document: item[this.importer.list[1]],
          };
          data.push(row)
        }


      });
      const origin = this.$root.auth.whitelabel.country == 'Peru' ? 'PER' : 'BRA'
      const url = `whitelabel/reserved/mass`;
      const form = {
        storeId: config.projectId,
        list: data,
        origin: origin
      }
      this.$axios.post(url, form).then((res) => {
        this.importer.processing = false
        this.reservedId = ''
        this.showSnack({
          text: "Importação processada com êxito.",
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        console.log('response of import', res)
        console.log('response data of import', res.data)
        this.importResult = res.data.data
        this.loadDocuments()
      });
    },
    preview() {
      let res = [];
      this.items.forEach((item) => {
        let key = item.split(" - ");
        res.push(parseInt(key[0]) - 1);
      });
      this.importer.list = res;
      this.importer.preview = true;
    },
    startDrag(item, i, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = item;
    },
    finishDrag(item, pos) {
      this.items.splice(pos, 1);
      this.items.splice(this.over.pos, 0, item);
      this.importer.preview = false;
      this.over = {};
    },
    onDragOver(item, pos, e) {
      const dir = this.startLoc < e.clientY ? "down" : "up";
      setTimeout(() => {
        this.over = { item, pos, dir };
      }, 50);
    },
    onChange(files) {
      console.log(files);
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = utils.sheet_to_json(ws, { header: 1 });
          this.importer.json = data;
        };

        reader.readAsBinaryString(this.file)
        setTimeout(() => {
          this.preview()
        }, 1000)
      }
    },
    submit() {
      const id = this.add.form.id
      this.processing = true;
      const form = {
        companyName: this.add.form.name,
        document: this.add.form.document,
        storeId: config.projectId
      }
      if (id) {
        form.id = id
        const url = `whitelabel/reserved/update`;
        this.$axios.put(url, form).then(() => {
          this.reservedId = ''
          this.showSnack({
            text: this.$t("sales.reserved.snackMsgSucess"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
          this.add.show = false;
          this.loadDocuments()
        });
      }
      else {
        const url = `whitelabel/reserved/add`;
        this.$axios.post(url, form).then(() => {
          this.reservedId = ''
          this.showSnack({
            text: this.$t("sales.reserved.snackMsgSucess"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
          this.add.show = false;
          this.loadDocuments()
        });
      }


    },
    loadDocuments() {
      this.loading = true;
      clearTimeout(this.calling)
      this.calling = setTimeout(() => {
        const documents = []
        const origin = this.$root.auth.whitelabel.country == 'Peru' ? 'PER' : 'BRA'
        const url = [`whitelabel/reserved/list?storeId=${config.projectId}&origin=${origin}`]
        if (this.search)
          url.push(`q=${this.search}`)

        this.$axios.get(url.join('&')).then((res) => {
          console.log('res', res.data)
          res.data.data.forEach((item) => {
            documents.push({ id: item.id, name: item.companyName.includes('"') ? item.companyName.replace('"', "”") : item.companyName, document: item.document, score: item.score, openScore: false, newScore: item.score, log: item.log, createdOn: item.createdOn })
          });

          this.documents = documents;
          this.loading = false;
        })
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-text {
  font-size: 0;
  text-indent: -999em;
}

fieldset {
  border: 1px solid #00000033;
  border-radius: 4px;
}

fieldset legend {
  //margin-left: 10px;
}
</style>
